import React from "react";
import { formatDiscount, formatPrice } from "../../../../utils/price.utils";
import { getProductPdpUrl } from "../../../../utils/url.utils";
import { Link, useNavigate } from "react-router-dom";
import blankcart from "../../../../assets/images/blank-cart.png";
import rightarrawwhite from "../../../../assets/icons/rightarrawwhite.png";

const CheckoutItems = ({ checkoutData }) => {
    const navigate = useNavigate();
    return (
        <div className="checkout-right_ck">
            {checkoutData?.data?.items.length === 0 ? (
                <div className="empty-cart">
                    <img
                        src={blankcart}
                        alt="Empty cart"
                        className="empty-cart-image"
                    />
                    <h3 className="empty-cart-title">
                        Your cart is feeling a little empty
                    </h3>
                    <p className="empty-cart-subtitle">
                        Discover our curated collection of premium rugs that transform
                        any space into a sanctuary of elegance and comfort.
                    </p>
                    <button
                        className="empty-cart-btn"
                        onClick={() => navigate("/")} //  send user back to home/shop
                    >
                        EXPLORE &nbsp;{" "}
                        <img src={rightarrawwhite} alt="Right Arrow" height={25} width={25} />
                    </button>
                </div>
            ) : (
                checkoutData?.data?.items.map((item) => (
                    <div className="cart-item" key={item.id}>
                        <div className="item-image">
                            <Link to={getProductPdpUrl(item.product?.action_url, item.product?.sku)} target="_blank" rel="noopener noreferrer">
                                <img
                                    className="img-cart-page pointer-crusser"
                                    src={item.product.media}
                                    alt="product"
                                />
                            </Link>
                        </div>
                        <div className="item-details">
                            <h4 className="item-title pointer-crusser">
                                <Link to={getProductPdpUrl(item.product?.action_url, item.product?.sku)} target="_blank" rel="noopener noreferrer">{item.product?.name}</Link>
                            </h4>
                            <p className="price_details">
                                {formatPrice(item.product.selling_price)}
                                {" "}
                                {item.product.discount > 0 && (
                                    <>
                                        <span className="sub-1">
                                            <del>{formatPrice(item.product?.mrp)}</del> &nbsp;
                                            <span className="dis-sub">
                                                {formatDiscount(item.product?.discount)}
                                            </span>
                                        </span>
                                    </>
                                )}
                            </p>
                            {item.product?.size === "0 cm" ? null : <p className="item-size">Size : {item.product?.size}</p>}
                            {item.product?.color ? null :
                                <p>
                                    Color:{" "}
                                    <span className={`color-${item.product.color.toLowerCase()}`}>
                                        {item.product.color}
                                    </span>
                                </p>}
                            <p className="item-qtn">
                                Quantity: {item.cart_qty}
                            </p>
                            <p style={{ 'color': "#918c8c", "fontSize": "12px" }}>{item.product?.return_non_return_days_label}
                            </p>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default CheckoutItems;
